import { BaseResponseType, apiClient } from 'shared/api';
import { Pageable, UploadReviewRequest } from 'shared/model';

import { AllReviewsResponse, BillingCard, CheckServicePlanResponse, MemberDetailResponse } from '../model/dto';
import { MainReviewsDto, ReviewDetailDto } from '../model/dto';
import { BillingCardOrderType, CheckServicePlanType, CouponTargetService, ReviewType } from '../types';
import { ApiError } from './customError';

export const uploadReviewImages = async (images: File[]): Promise<string[]> => {
  const formData = new FormData();
  images.forEach((image) => {
    formData.append('images', image);
  });

  // NOTE: FormData 전달하기 위해 강제 형변환
  const response = await apiClient.post('/review/images', formData as unknown as Record<string, unknown>);
  return response.data.result;
};

export const uploadReview = async (request: UploadReviewRequest): Promise<void> => {
  const { data } = await apiClient.post('/review', request);
  if (!data.isSuccess) throw new ApiError(data);
  return data.result;
};

export const getAllReviews = async ({
  type,
  pageable,
}: {
  type: ReviewType;
  pageable: Pageable;
}): Promise<AllReviewsResponse> => {
  const { data } = await apiClient.get(`/review/main/${type}`, pageable);

  return data.result;
};

export const getMemberDetail = async (): Promise<MemberDetailResponse> => {
  const { data } = await apiClient.get('/member');
  return data.result;
};

export const getCheckService = async (serviceType: CheckServicePlanType): Promise<CheckServicePlanResponse> => {
  const { data } = await apiClient.get(`/checkservice/${serviceType}/plans`);

  return data.result;
};

export const validateCoupon = async (
  code: string,
  targetAmount: number,
  couponTargetService: CouponTargetService,
): Promise<BaseResponseType<{ isApplicable: boolean; discount: number }>> => {
  const { data } = await apiClient.get(`/coupons/validation`, {
    code,
    targetAmount,
    couponTargetService,
  });

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};

export const getReviewsByType = async ({
  type,
  pageable,
}: {
  type: ReviewType;
  pageable: Pageable;
}): Promise<MainReviewsDto> => {
  const { data } = await apiClient.get(`/review/main/${type}`, {
    ...pageable,
  });
  return data.result;
};

export const getBestReviews = async ({
  type,
  pageable,
}: {
  type: ReviewType;
  pageable: Pageable;
}): Promise<MainReviewsDto> => {
  const { data } = await apiClient.get(`/review/main/${type}/best`, {
    ...pageable,
  });
  return data.result;
};

export const getReviewDetail = async (id: number): Promise<ReviewDetailDto> => {
  const { data } = await apiClient.get(`/review/${id}/detail`);

  return data.result;
};

/**
 *
 * @description 자동 결제 카드 등록 여부 조회
 */
export const checkBillingCards = async (orderType?: BillingCardOrderType): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.get('/order/check-billing-cards', {
    orderType,
  });

  // NOTE: 커스터미징해서 에러를 처리하는 경우에는 에러를 던지지 않습니다.
  // if (!data.isSuccess) {
  //   throw new ApiError(data);
  // }

  return data;
};

/**
 * @description 자동 결제 카드 조회
 */
export const getBillingCards = async (
  memberId: string,
  orderType?: BillingCardOrderType,
): Promise<{
  billingCardInfoDtos: BillingCard[];
}> => {
  const { data } = await apiClient.get(`/member/${memberId}/billing-cards`, {
    orderType,
  });

  return data.result;
};
